import { CSSObject } from '@emotion/react';

export const responsiveContainerStyles = (): CSSObject => ({ height: '100%', width: '100%' });
